import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Logo } from '../components/Logo';
import { ThemeToggle } from '../components/ThemeToggle';
import { Badge } from '../components/primitives';
import { Footer } from '../components/Layout';
import { useAdmin } from './context';

const TAB_BASE =
  'rounded-full px-4 py-2 text-sm font-medium transition-colors';
const TAB_ACTIVE = 'bg-brand text-brand-contrast';
const TAB_IDLE = 'text-muted hover:text-foreground hover:bg-input';

export function AdminLayout() {
  const { me } = useAdmin();
  const auth = useAuth();
  const isMaster = me.role === 'master';

  return (
    <div className="flex min-h-screen flex-col">
      <header className="sticky top-0 z-40 border-b border-border/60 bg-background/80 backdrop-blur">
        <div className="mx-auto flex w-full max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-3 sm:px-6">
          <div className="flex items-center gap-4">
            <NavLink to="/" aria-label="Knocking Forms home" className="rounded-sm">
              <Logo className="h-[26px]" />
            </NavLink>
            <span className="hidden text-xs font-semibold uppercase tracking-[0.18em] text-muted sm:inline">
              Forms Hub · Admin
            </span>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden items-center gap-2 sm:flex">
              <span className="max-w-[220px] truncate text-sm text-muted" title={me.email}>
                {me.name ?? me.email}
              </span>
              <Badge tone={isMaster ? 'brand' : me.role === 'admin' ? 'ok' : 'muted'}>{me.role}</Badge>
            </span>
            <ThemeToggle />
            <button
              type="button"
              onClick={() => void auth.signoutRedirect()}
              className="rounded-full border border-border px-3.5 py-1.5 text-xs font-medium text-muted transition-colors hover:bg-input hover:text-foreground"
            >
              Sign out
            </button>
          </div>
        </div>
        <nav className="mx-auto flex w-full max-w-6xl gap-1 overflow-x-auto px-4 pb-3 sm:px-6" aria-label="Admin sections">
          <NavLink to="/admin" end className={({ isActive }) => `${TAB_BASE} ${isActive ? TAB_ACTIVE : TAB_IDLE}`}>
            Forms
          </NavLink>
          {isMaster && (
            <NavLink to="/admin/audit" className={({ isActive }) => `${TAB_BASE} ${isActive ? TAB_ACTIVE : TAB_IDLE}`}>
              Audit log
            </NavLink>
          )}
          {isMaster && (
            <NavLink to="/admin/users" className={({ isActive }) => `${TAB_BASE} ${isActive ? TAB_ACTIVE : TAB_IDLE}`}>
              Users
            </NavLink>
          )}
        </nav>
      </header>
      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-6 sm:px-6 sm:py-8">
        <Outlet />
      </main>
      <Footer internal />
    </div>
  );
}
